import React, { useEffect, useRef, useState } from 'react';
import useFadeInSection from '../hooks/useFadeInSection';
import useAppleAnimation from '../hooks/useAppleAnimation';

const ValueProposition = () => {
  const fadeInRef = useAppleAnimation('apple-slide-up');
  const cardsRef = useAppleAnimation('staggered-animation');

  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-6">
        <div id="benefits" className="text-center mb-12 scroll-mt-96 md:scroll-mt-20" ref={fadeInRef}>
          <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-4">
            압도적인 혜택, 숫자가 증명합니다
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            더모아벤처스는 단순한 투자를 넘어, 고객님의 자산을 지키고 키우는 가장 확실한 방법을 제안합니다.
          </p>
        </div>
        
        {/* 혜택 카드들 */}
        <div ref={cardsRef} className="grid md:grid-cols-3 gap-8">
          {/* 소득공제 카드 */}
          <div className="staggered-animation bg-gray-50 p-8 rounded-xl border border-gray-200 text-center group hover:shadow-lg transition-shadow">
            <div className="text-blue-500 mb-4">
              <svg className="w-12 h-12 mx-auto" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6"/>
              </svg>
            </div>
            <h3 className="text-xl font-bold mb-3 text-gray-800">최대 100% 소득공제</h3>
            <p className="text-gray-600 leading-relaxed">
              3천만원 투자 시 3천만원 전액, 5천만원 투자 시 4천 4백만원에 대한 소득공제 혜택을 통해 
              과세표준을 획기적으로 낮출 수 있습니다.
            </p>
          </div>

          {/* 안정성 카드 */}
          <div className="staggered-animation bg-gray-50 p-8 rounded-xl border border-gray-200 text-center group hover:shadow-lg transition-shadow">
            <div className="text-blue-500 mb-4">
              <svg className="w-12 h-12 mx-auto" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z"/>
              </svg>
            </div>
            <h3 className="text-xl font-bold mb-3 text-gray-800">안정적인 원금 상환</h3>
            <p className="text-gray-600 leading-relaxed">
              주식 투자가 아닌 '전환사채(CB)' 형태로 투자하여, 만기 시 원금과 확정 이자를 상환받는 
              안정성이 높은 투자 상품입니다.
            </p>
          </div>

          {/* 비과세 카드 */}
          <div className="staggered-animation bg-gray-50 p-8 rounded-xl border border-gray-200 text-center group hover:shadow-lg transition-shadow">
            <div className="text-blue-500 mb-4">
              <svg className="w-12 h-12 mx-auto" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 17h8m0 0V9m0 8l-8-8-4 4-6-6"/>
              </svg>
            </div>
            <h3 className="text-xl font-bold mb-3 text-gray-800">투자수익 비과세 혜택</h3>
            <p className="text-gray-600 leading-relaxed">
              벤처투자조합 출자로 얻은 양도차익은 비과세 대상이며, 배당소득 또한 분리과세 적용으로 
              종합소득세 부담을 줄일 수 있습니다.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ValueProposition;